import { Component, Mixins, Prop } from 'vue-property-decorator';

import DebugModel from '@/forms/FormElements/Common/DebugModel/DebugModel.vue';
import EmailRow from '@/forms/FormElements/Rows/EmailRow/EmailRow.vue';
import ButtonRow from '@/forms/FormElements/Rows/ButtonRow/ButtonRow.vue';

import { getComponentProps } from '@/utils/vueUtils';
import {
  DerUnsubscribeViewModel,
  DerUnsubscribeForm,
  apiData,
} from '@/modules/UnsubscribeModule/UnsubscribeModule.types';
import FormValidationMixin from '@/forms/FormElements/Mixins/FormValidationMixin';
import getValidation from './UnsubscribeModule.validations';
import Message from '@/forms/Validations/Message';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import {
  GET_LIST,
  UNSUBSCRIBE_EMAIL,
  UNSUBSCRIBE_DER_EMAIL,
  UnsubscribeModuleState,
  SET_MESSAGE,
} from '@/modules/UnsubscribeModule/UnsubscribeModule.store';

const { validations, model, messages } = getValidation();

@Component({
  validations,
  props: getComponentProps<DerUnsubscribeViewModel>({
    SubscriptionId: 11,
    SubscriptionFamilyId: 23,
    ShowAll: true,
    isDerUnsub: true,
    Text: `<p><strong>You have successfully unsubscribed.</strong></p><p>Thanks for following this expedition&mdash;we hope that one day your friends and family will be following&nbsp;<strong>your</strong> expedition!</p><p><a href="/EPiServer/CMS/Content/destinations,,200/?epieditmode=False">See all our expeditions</a> and start planning, or get inspired in our <a href="/EPiServer/CMS/Content/video-library,,404/?epieditmode=False">video gallery</a>.</p>`,
  }),
  components: {
    EmailRow,
    DebugModel,
    ButtonRow,
  },
})
export default class UnsubscribeModule extends Mixins(FormValidationMixin, StoreModuleMixin) {
  state!: UnsubscribeModuleState;

  @Prop()
  readonly p!: DerUnsubscribeViewModel;

  model: DerUnsubscribeForm = model;

  messages: Message[] = messages;

  get showAllBtn() {
    return this.p.ShowAll && this.state.IsSubmitted && !this.state.ShowAllBtnWasClicked;
  }

  get isDerAndNoIDs() {
    return !this.p.SubscriptionId && !this.p.SubscriptionFamilyId && this.p.isDerUnsub;
  }

  async onUnsubscribeEmail(unsubscribeData?) {
    if (this.isDerAndNoIDs) {
      this.getMutation(SET_MESSAGE)(`<span>Oops, something went wrong.</span>`);
      return;
    }
    const data: apiData = {
      email: this.model.Person.Email,
    };
    try {
      if (this.p.isDerUnsub) {
        data.id = this.p.SubscriptionId;
        data.familyId = this.p.SubscriptionFamilyId;
        if (this.p.Text) data.message = this.p.Text;
        this.getAction(UNSUBSCRIBE_DER_EMAIL)(unsubscribeData || data);
      } else {
        this.getAction(UNSUBSCRIBE_EMAIL)(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async onGetAllEmailsList() {
    const data: apiData = {
      email: this.model.Person.Email,
      id: this.p.SubscriptionId,
      familyId: this.p.SubscriptionFamilyId,
    };
    try {
      this.getAction(GET_LIST)(data);
    } catch (error) {
      console.error(error);
    }
  }

  created() {
    this.$on('submit', () => {
      this.onUnsubscribeEmail();
    });
  }
  mounted() {
    if (this.isDerAndNoIDs)
      this.getMutation(SET_MESSAGE)(`<span>Oops, something went wrong.</span>`);
  }
}
